import { IconButton, Tooltip } from '@material-ui/core'
import { WarningRounded } from '@material-ui/icons'
import { useFlow } from 'contexts/Flow/flowContext'
import useTranslator from 'utils/hooks/Translator'

export function WarningButton() {
  const { getTranslation } = useTranslator()
  const { dispatch } = useFlow()

  return (
    <Tooltip
      title={getTranslation('linter.warnings.buttonTooltip')}
      placement="right"
    >
      <IconButton
        onClick={() => dispatch({ type: 'openLinterWarningModal' })}
        style={{
          width: 44,
          height: 44,
          margin: '32px auto 6px 6px',
          background: '#FFA500',
          color: '#fff',
        }}
      >
        <WarningRounded fontSize="medium" />
      </IconButton>
    </Tooltip>
  )
}
